import { type ITabItem } from 'shared/ui'
import { TimePeriodInfo } from 'pages/settings/ui/BillingPlan/ui/TimePeriodInfo/TimePeriodInfo'
import {
  type BillingPeriod,
  type ISelectedPlanInfo,
} from 'pages/settings/ui/BillingPlan/store/plansSelectorStore'

type IUpgradePeriodInfoProps = {
  className: string
  period: BillingPeriod
  handleSetPeriod: (tab: ITabItem<BillingPeriod>) => void
  isPlanLoading: boolean
  annualSavings: number
  shouldShowPeriodTabs: boolean
  selectedPlanInfo: ISelectedPlanInfo | null
  isUpgradeModalV2_2: boolean
  showDivider?: boolean
}

export const UpgradePeriodInfo = ({
  className,
  period,
  handleSetPeriod,
  isPlanLoading,
  annualSavings,
  shouldShowPeriodTabs,
  selectedPlanInfo,
  isUpgradeModalV2_2,
  showDivider = false,
}: IUpgradePeriodInfoProps) => {
  return (
    <div className={className} style={isUpgradeModalV2_2 ? { marginBottom: 48 } : undefined}>
      <TimePeriodInfo
        period={period}
        handleSetPeriod={(selectedPeriod) => {
          handleSetPeriod({
            key: selectedPeriod,
            name: selectedPeriod === 'monthly' ? 'Monthly' : 'Annually',
          })
        }}
        isPlanLoading={isPlanLoading}
        annualSavings={annualSavings}
        shouldShowPeriodTabs={shouldShowPeriodTabs}
        selectedPlanInfo={selectedPlanInfo}
        showDivider={showDivider}
      />
    </div>
  )
}
